import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=04ba9f51&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('04ba9f51')) {
      api.createRecord('04ba9f51', component.options)
    } else {
      api.reload('04ba9f51', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=04ba9f51&", function () {
      api.rerender('04ba9f51', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2Sp7HggW4i7ad/JS/offershelp.vue"
export default component.exports